<template>
  <div
    :data-popid="id"
    class="tooltip fade bs-tooltip-right"
    role="tooltip"
    x-placement="right"
    :style="{top: top + 'px!important', left: left + 'px'}"
    @mouseenter="mouse($event)"
    @mouseleave="mouse($event)"
  >
    <div class="arrow"></div>
    <div class="tooltip-inner">
      <div v-if="loading" class="mask">
        <div class="sk-three-bounce">
          <div class="sk-child sk-bounce1 bg-white"></div>
          <div class="sk-child sk-bounce2 bg-white"></div>
          <div class="sk-child sk-bounce3 bg-white"></div>
        </div>
      </div>
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "loading"],
  data() {
    return {
      top: 0,
      left: 0
    };
  },
  computed: {
    popData() {
      return this.$store.state.popover;
    }
  },
  watch: {
    popData: {
      handler() {
        if(!this.popData.event) return;
        let bottom = $(window).height()-($(this.popData.event.target).offset().top-$(document).scrollTop());
        if(false && this.popData.id == "supplierGrade"){
        	if(bottom < 430){
        		this.top = $(this.popData.event.target).offset().top-410;
            $("[data-popid=supplierGrade] .arrow").css({"top":"auto","bottom":"6px"})
        	}else{
        		this.top = $(this.popData.event.target).offset().top;
            $("[data-popid=supplierGrade] .arrow").css({"top":"6px","bottom":"auto"})
        	}
	  		}else{
	  			this.top = $(this.popData.event.target).offset().top;
          $("[data-popid=supplierGrade] .arrow").css({"top":"6px","bottom":"auto"})
	  		}    
        this.left =
          $(this.popData.event.target).offset().left +
          $(this.popData.event.target).width();
        if(this.popData.id == "editSettleMethod"){
        	this.left =
          $(this.popData.event.target).offset().left +
          $(this.popData.event.target).width()-18;
          this.top = $(this.popData.event.target).offset().top+20;
        }
      },
      deep: true
    }
  },
  methods: {
    mouse(event) {
      if (event.type == "mouseenter") {
        clearTimeout(this.$popTimeout);
      } else if (event.type == "mouseleave") {
        let o = event.relatedTarget || event.toElement;
        if(!o) return;
        this.$store.commit("setPopover", { event });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.arrow {
  left: 0;
  margin-left: 0;
  top: 6px;
}
.tooltip-inner{
  position: relative;
  max-width: 1000px!important;
}
.mask{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, .6);
  .sk-three-bounce{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(.5);
    margin: 0 auto;
  }
}
</style>
